<template>
    <div class="max-w-sm px-16">
      <p class="">{{ $t('auth.choose.title') }}</p>
      <ria-button class="block mx-auto mt-4 text-base" :text="$t('auth.choose.register')" :action="openRegister" />
      <ria-button class="block mx-auto mt-4 text-base" :text="$t('auth.choose.login')" :outline="true" :action="openLogin" />

      <div class="flex items-center mt-5">
        <hr class="w-3/4">
        <p class="mx-3 text-xs">o</p>
        <hr class="w-3/4">
      </div>

      <a class="mt-5 text-secondary" @click="close">{{ $t('auth.choose.buy_anonymously') }}</a>
    </div>
</template>

<script>
  import RiaButton from "@/components/common/ria-button"

  export default {
    name: "auth-choice",
    components : {
      RiaButton
    },
    methods: {
      close() {
        this.$emit('buyAnonymously')
      },
      openLogin() {
        this.$emit('startLogin')
      },
      openRegister() {
        this.$emit('startRegister')
      }
    }
  };
</script>

<style scoped>
    button {
      text-transform: uppercase;
    }

    p, a {
      @apply text-base text-center
    }

    a {
      @apply block cursor-pointer
    }
</style>

